module.exports = __webpack_public_path__ + "img/dengbottom.6953e962.png";